import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { isEmptyBlock } from '../../types/api/Block';
import { isLocationMembershipsBlock, LocationMembershipsBlock } from '../../_blocks/LocationMemberships';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type LocationMembershipsWidget = WidgetShape<[LocationMembershipsBlock], WidgetType.locationMemberships>;

/**
 * LocationMemberships Widget used in PersonalProfile Page.
 */
export function LocationMembershipsWidget({ blocks, elementType, ...headerProps }: LocationMembershipsWidget) {
  const { t } = useSonTranslation('ConnectedLocations');

  const locationMembershipsBlock = blocks.find(isLocationMembershipsBlock);

  if (locationMembershipsBlock && isEmptyBlock(locationMembershipsBlock)) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.LOCATION} title={t('widgetTitle')}>
      {locationMembershipsBlock && <LocationMembershipsBlock {...locationMembershipsBlock} />}
    </DefaultWidgetWithHeader>
  );
}
